<template>
  <div>
    <div class="bg-dark text-white">
  <h5 class="text-center p-4 m-0">PhotoApp</h5>
</div>
  </div>
</template>